import { Config } from './config';
import { Util } from './util';

class ComplaintsTable {

    constructor() {
        this.CONFIG = new Config();
        this.TBODY = document.getElementById('complaintsTableBody');
        this.TBODY_SPINNER = document.getElementById('complaintsTableBodySpinner');
        this.MODAL = document.getElementById('deleteComplaintModal');
        this.MODAL_TBODY = document.getElementById('deleteComplaintModalTableBody');
        this.MODAL_BTN = document.getElementById('deleteComplaintModalBtn');
        this.CUSTOM_EVENT_SCROLL_BOTTOM_DETECTED = 'scrollbottomdetected';
        this.CUSTOM_EVENT_DELETE_COMPLAINT = 'deletecomplaint';
        this.IS_JSON_AVAILABLE = true;
        this.NOT_FOUND_COMPLAINTS_P = document.getElementById('notFoundComplaintsP');
    }


    GetRootElm() {
        return this.TBODY;
    }


    LoadingStart() {
        this.TBODY_SPINNER.classList.remove('invisible');
    }


    LoadingStop() {
        this.TBODY_SPINNER.classList.add('invisible');
    }


    VisibleNoComplaints() {
        this.NOT_FOUND_COMPLAINTS_P.classList.add('d-block');
        this.NOT_FOUND_COMPLAINTS_P.classList.remove('d-none');
    }


    HiddenNoComplaintsP() {
        this.NOT_FOUND_COMPLAINTS_P.classList.remove('d-block');
        this.NOT_FOUND_COMPLAINTS_P.classList.add('d-none');
    }


    Append(object) {
        const complaints = object['complaints'];
        const complaintContacts = object['complaint_contacts'];
        const complaintTransactions = object['complaint_transactions'];
        const statusClassification = object['status_classification'];
        const status = object['status'];
        const notificationType = object['notification_type'];
        const inquirySourceType = object['inquiry_source_type'];
        if(complaints != null && complaints.length > 0) {
            const fragment = document.createDocumentFragment();
            for(let i = 0; i < complaints.length; i++) {
                const o = complaints[i];
                const tr = document.createElement('TR');
                fragment.appendChild(tr);
// This is just case when you want to download all accounts, etc.
//                const inputTd = document.createElement('TD');
//                tr.appendChild(inputTd);
//                const input = document.createElement('INPUT');
//                input.type = 'checkbox';
//                input.name = this.MEDIES_ACCOUNT_CHK_NAME;
//                input.value = o.user_id;
//                inputTd.appendChild(input);
                const shopIdTd = document.createElement('TD');
                shopIdTd.textContent = o.shop_id;
                tr.appendChild(shopIdTd);
                const usernameTd = document.createElement('TD');
                usernameTd.textContent = o.username;
                tr.appendChild(usernameTd);
                const deadlineTd = document.createElement('TD');
                deadlineTd.textContent = (o.deadline != null && o.deadline !== '') ? o.deadline.split('T')[0] : '';
                tr.appendChild(deadlineTd);
                const statusTd = document.createElement('TD');
                const statusP = document.createElement('P');
                statusP.innerHTML = statusClassification[o.status_classification] + '<br/>' + status[o.status];
                statusTd.appendChild(statusP);
                tr.appendChild(statusTd);
                const notificationTypeTd = document.createElement('TD');
                notificationTypeTd.textContent = o.notification_type != null ? notificationType[o.notification_type] : '';
                tr.appendChild(notificationTypeTd);
                const contactsTd = document.createElement('TD');
                if(complaintContacts != null) {
                    for(let j = 0; j < complaintContacts.length; j++) {
                        const oo = complaintContacts[j];
                        if(o.id === oo.complaint_id) {
                            const p = document.createElement('P');
                            const html = oo.inquiry_date.split('T')[0] + '<br/>' + inquirySourceType[oo.inquiry_source_type] + '<br/>' + oo.contacts;
                            p.innerHTML = html;
                            contactsTd.appendChild(p);
                        }
                    }
                }
                tr.appendChild(contactsTd);
                const transactionTd = document.createElement('TD');
                if(complaintTransactions != null) {
                    for(let j = 0; j < complaintTransactions.length; j++) {
                        const oo = complaintTransactions[j];
                        if(o.id === oo.complaint_id) {
                            const p = document.createElement('P');
                            const html = oo.transaction_code + '<br/>' + oo.transaction_date.split('T')[0] + '<br/>' + (Math.round(oo.amount*100) / 100).toLocaleString('ja-JP');
                            p.innerHTML = html;
                            transactionTd.appendChild(p);
                        }
                    }
                }

                const ActionRequiredTd = document.createElement('TD');
                if(complaintTransactions != null) {
                    for(let j = 0; j < complaintTransactions.length; j++) {
                        const oo = complaintTransactions[j];
                        if(o.id === oo.complaint_id) {
                            if(oo.action_required_flag == 1){
                                const p = document.createElement('P');
                                const html = '<br/>' + "　有" + '<br/>';
                                p.innerHTML = html;
                                ActionRequiredTd.appendChild(p);
                            }
                        }
                    }
                }
                tr.appendChild(ActionRequiredTd);

                tr.appendChild(transactionTd);
                const actionTd = document.createElement('TD');
                actionTd.classList.add('actions-cell');
                tr.appendChild(actionTd);
                const editA = document.createElement('A');
                editA.classList.add('btn', 'btn-edit');
                editA.href = this.CONFIG.URL_COMPLAINTS + '/' + o.id + '/edit';
                editA.textContent = '詳細・編集';
                actionTd.appendChild(editA);
                const deleteA = document.createElement('A');
                deleteA.classList.add('btn', 'btn-delete');
                deleteA.textContent = '削除';
                deleteA.href = '';
                deleteA.dataset.toggle = 'modal';
                deleteA.dataset.target = '#deleteComplaintModal';
                deleteA.addEventListener('click', (e) => { this.handleDeleteComplaint(tr, o.id); }, false);
                actionTd.appendChild(deleteA);
            }
            this.TBODY.appendChild(fragment);
        }
    }


    Clear() {
        while(this.TBODY.firstChild) {
            this.TBODY.removeChild(this.TBODY.firstChild);
        }
    }


    handleDeleteComplaint(tr, id) {
        while(this.MODAL_TBODY.firstChild) {
            this.MODAL_TBODY.removeChild(this.MODAL_TBODY.firstChild);
        }
        const clone = tr.cloneNode(true);
        clone.lastElementChild.remove();
        this.MODAL_TBODY.appendChild(clone);
        this.MODAL_BTN.href = this.CONFIG.URL_COMPLAINTS + '/' + id;
        this.MODAL_BTN.tmp = tr;
    }


    setUpScrollEventListener() {
        let scrollTimerId;
        window.addEventListener('scroll', (e) => {
            if(scrollTimerId != null) {
                clearTimeout(scrollTimerId);
            }
            scrollTimerId = setTimeout(() => {
                const y = window.pageYOffset + window.innerHeight - (window.pageYOffset + this.TBODY.getBoundingClientRect().y);
                const height = this.TBODY.offsetHeight;
                if(height !== 0 && y > height * 0.9) {
                    const event = new CustomEvent(this.CUSTOM_EVENT_SCROLL_BOTTOM_DETECTED);
                    this.TBODY.dispatchEvent(event);
                }
            }, 500);
        }, false);
    }


    closeModal() {
        const o = document.querySelector('button[data-dismiss="modal"]');
        if(o != null) {
            o.click();
        }
    }


    handleBeforeSend(e) {
        if(e.target.tagName !== 'A') {
           return;
        }
        if(!this.IS_JSON_AVAILABLE) {
            e.preventDefault();
        }
        this.IS_JSON_AVAILABLE = false;
    }


    handleSuccess(e) {
        if(e.target.tagName !== 'A') {
           return;
        }
        const tr = e.target.tmp;
        if(tr != null) {
            tr.remove();
        }
    }


    handleError(e) {
        if(e.target.tagName !== 'A') {
           return;
        }
        if(e.detail[2] != null && e.detail[2].status === 401) {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(e.detail[0]), this.CONFIG.APP_MAIN.childNodes[0]);
            window.scrollTo(0,0)
            return;
        }
        const detail = e.detail[0];
        if(detail == null) {
            return;
        }
        const msg = detail.msg;
        if(msg !== '') {
            this.CONFIG.APP_MAIN.insertBefore(Util.GenFlashDanger(msg), this.CONFIG.APP_MAIN.childNodes[0]);
        }
    }


    handleComplete(e) {
        if(e.target.tagName !== 'A') {
           return;
        }
        this.IS_JSON_AVAILABLE = true;
        this.closeModal();
    }


    setUpRailsUjsEventListener() {
        document.body.addEventListener('ajax:beforeSend', (e) => { this.handleBeforeSend(e) }, false);
        document.body.addEventListener('ajax:success', (e) => { this.handleSuccess(e) }, false);
        document.body.addEventListener('ajax:error', (e) => { this.handleError(e) }, false);
        document.body.addEventListener('ajax:complete', (e) => { this.handleComplete(e) }, false);
    }

    Run() {
        this.setUpScrollEventListener();
        this.setUpRailsUjsEventListener();
    }

}
export { ComplaintsTable }
